import React from 'react'
import { StaticContext } from 'react-router'
import { Redirect, Route, RouteComponentProps } from 'react-router-dom'
import * as firebase from 'firebase/app'
import 'firebase/auth'

const handleRender = (Component: any, renderComponent: any, props: any) => {
	const user = firebase.auth().currentUser

	if (!!user) {
		if (Component) {
			return <Component {...props} />
		} else if (renderComponent) {
			return renderComponent({ ...props })
		}
	} else {
		return <Redirect to={{
			pathname: '/login',
			state: { from: props.location }
		}} />
	}
}

const PrivateRoute = ({ component, render, ...rest }: any) => {
	return (
		<Route {...rest} render={(props: RouteComponentProps<any, StaticContext, any>) => handleRender(component, render, props)} />
	)
}

export default PrivateRoute
